import Keycloak from 'keycloak-js';
import axios, {AxiosRequestConfig} from 'axios';
import {Route} from 'vue-router';
import {getValidToken} from '@/components/auth/token';
import {KEYCLOAK_ROOT_URL} from '@/constants/urls';
import {setKeycloak} from "@/components/auth/keycloak";

const keycloak = Keycloak({
  "realm": "sensefly",
  "clientId": "my-sensefly",
  "url": `${KEYCLOAK_ROOT_URL}/auth`
});

export default (to: Route, next: () => void) => keycloak
    .init({})
    .success(() => {
      setKeycloak(keycloak);
      if (to.name !== 'Login' && !keycloak.authenticated) {
        keycloak.login();
      } else {
        tokenInterceptors();
      }

      next();
    })
    .error(() => {
      throw new Error('Login failed!');
    });

function tokenInterceptors() {
  axios.interceptors.request.use(async (config: AxiosRequestConfig) => {
    const token = await getValidToken();
    config.headers.Authorization = `Bearer ${token}`;
    return config;
  });
}



// WEBPACK FOOTER //
// ./src/components/auth/init.ts